import script from "./DonationDonutChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DonationDonutChart.vue?vue&type=script&setup=true&lang=js"

import "./DonationDonutChart.vue?vue&type=style&index=0&id=8322dd32&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8322dd32"]])

export default __exports__